<template>
    <!-- Help Section (Only shown when not on contact page) -->
    <div class="profile-section text-center pt-2 pl-2" v-if="currentRoute != 'contact-us'">
        <h5 class="text-left">
            <label class="underline">
                <a href="javascript:void(0)" @click="$router.push({ path: '/contact-us'})" class="text-black">
                    <NeedHelpIcon :iconClass="pt-5" />
                    Need Help?
                </a>
            </label>
        </h5>
        <div class="profile-section">
            <ul class="list-unstyled mb-0">
                <li><strong>Email:</strong> <a href="mailto:support@mywingio.com">support@mywingio.com</a></li>
                <li><strong>Phone:</strong> <a href="tel:+447349970810">+44 7349 970810</a></li>
                <li>
                    <strong>More details:</strong>
                    <a href="https://www.mywingio.com/how-it-works" target="_blank" rel="noopener noreferrer">
                        https://www.mywingio.com/how-it-works
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <!-- Copyright Section -->
    <div class="bg-dark text-white px-5 pt-4 pb-6 text-sm text-center footer-spacing">
        <p>Wingio {{ new Date().getFullYear() }}. All rights reserved</p>
        <hr>
        <div class="footer-links">
            <a href="https://www.mywingio.com/privacy-policy" target="_blank">Privacy Policy</a>
            <a href="https://www.mywingio.com/terms-of-service" target="_blank">Terms & Conditions</a>
            <a href="https://www.mywingio.com/shipping-warranty" target="_blank">Shipping & Warranty</a>
        </div>
    </div>

    <!-- Fixed Bottom Navigation -->
    <div class="bottom-nav-container">
        <div class="bottom-nav">
            <a 
                href="javascript:void(0)" 
                class="nav-item" 
                :class="{ 'active': currentRoute === 'Kids Devices' }"
                @click="navigateAndClose('/kids-device')"
            >
                <DashboardIcon :iconClass="{ 'svg-icon-active': routerName === 'Kids Devices' }" />
                <span>Dashboard</span>
            </a>
            <a 
                href="javascript:void(0)" 
                class="nav-item"
                :class="{ 'active': currentRoute === 'Applications List' || currentRoute === 'Application' }"
                @click="navigateAndClose('/play-store')"
            >
                <ApplicationsIcon :iconClass="{ 'svg-icon-active': routerName === 'Applications List' }" />
                <span>Apps</span>
            </a>

            <a 
                href="javascript:void(0)" 
                class="nav-item"
                :class="{ 'active': currentRoute === 'requests' }"
                @click="navigateAndClose('/requests')"
            >
                <AppRequestListIcon :iconClass="{ 'svg-icon-active': routerName === 'requests' }" />
                <span>Request</span>
            </a>

            <a 
                v-if="enableSchedule"
                href="javascript:void(0)" 
                class="nav-item nav-item-with-badge"
                :class="{ 'active': currentRoute === 'schedule' }"
                @click="navigateAndClose('/schedule')"
            >
                <div class="icon-wrapper">
                    <ScheduleIcon :iconClass="{ 'svg-icon-active': routerName === 'schedule' }" />
                    <label class="new-badge">NEW</label>
                </div>
                <span>Schedule</span> <!-- This was missing -->
            </a>

            <a 
                href="javascript:void(0)" 
                class="nav-item"
                :class="{ 'active': showMoreMenu }"
                @click="toggleMoreMenu()"
            >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" :fill="showMoreMenu ? '#6366f1' : '#666'"/>
                </svg>
                <span>More</span>
            </a>
        </div>
    </div>

    <!-- More Menu Overlay -->
    <div class="more-menu-overlay" :class="{ 'show': showMoreMenu }" @click="closeMoreMenu()"></div>
    
    <!-- More Menu Panel -->
    <div class="more-menu-panel" :class="{ 'show': showMoreMenu }">
        <div class="more-menu-header">
            <h5>More Options</h5>
            <button class="close-btn" @click="closeMoreMenu()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="#333"/>
                </svg>
            </button>
        </div>
        <div class="more-menu-content text-left">
            <!--<a 
                href="javascript:void(0)" 
                class="more-menu-item"
                :class="{ 'active': currentRoute === 'requests' }"
                 @click="navigateAndClose('/requests')"
            >
                <div class="menu-icon">
                    <AppRequestListIcon :iconClass="{ 'svg-icon-active': routerName === 'requests' }" />
                </div>
                <div class="menu-text">
                    <div class="menu-title">Requests</div>
                    <div class="menu-subtitle">App installation requests</div>
                </div>
                <span v-if="requestCount > 0" class="badge badge-warning">{{ requestCount }}</span>
            </a>-->
            <a 
                href="javascript:void(0)" 
                class="more-menu-item"
                :class="{ 'active': currentRoute === 'geofence' }"
                @click="navigateAndClose('/geofence')"
            >
                <div class="menu-icon">
                    <GeofenceIcon :iconClass="{ 'svg-icon-active': routerName === 'geofence' }" />
                </div>
                <div class="menu-text">
                    <div class="menu-title">Location Alerts</div>
                    <div class="menu-subtitle">Manage safe zones and get alerts when your child arrives or leaves</div>
                </div>
            </a>
            <a 
                href="javascript:void(0)" 
                class="more-menu-item"
                :class="{ 'active': currentRoute === 'contacts' }"
                @click="navigateAndClose('/contacts')"
            >
                <div class="menu-icon">
                    <AddressBookIcon :iconClass="{ 'svg-icon-active': routerName === 'contacts' }" />
                </div>
                <div class="menu-text">
                    <div class="menu-title">Manage Contacts</div>
                    <div class="menu-subtitle">Manage Secure Contacts</div>
                </div>
            </a>

            <a 
                href="javascript:void(0)" 
                class="more-menu-item"
                :class="{ 'active': currentRoute === 'manage-chrome' }"
                @click="navigateAndClose('/manage-chrome')"
            >
                <div class="menu-icon">
                    <ChromeIcon :iconClass="{ 'svg-icon-active': routerName === 'manage-chrome' }" />
                </div>
                <div class="menu-text">
                    <div class="menu-title">Manage Chrome</div>
                    <div class="menu-subtitle">Configure allow and block urls</div>
                </div>
            </a>

            <a 
                href="javascript:void(0)" 
                class="more-menu-item"
                :class="{ 'active': currentRoute === 'global-settings' }"
                @click="navigateAndClose('/global-settings')"
            >
                <div class="menu-icon">
                    <SettingIcon :iconClass="{ 'svg-icon-active': routerName === 'global-settings' }" />
                </div>
                <div class="menu-text">
                    <div class="menu-title">Settings</div>
                    <div class="menu-subtitle">Device settings & controls</div>
                </div>
            </a>

            <a 
                href="javascript:void(0)" 
                class="more-menu-item"
                :class="{ 'active': currentRoute === 'timeline' }"
                @click="navigateAndClose('/timeline')"
            >
                <div class="menu-icon">
                    <ReportIcon :iconClass="{ 'svg-icon-active': routerName === 'timeline' }" />
                </div>
                <div class="menu-text">
                    <div class="menu-title">Timeline</div>
                    <div class="menu-subtitle">Usage analytics & insights</div>
                </div>
            </a>

            <a 
                href="javascript:void(0)" 
                class="more-menu-item"
                :class="{ 'active': currentRoute === 'reports' }"
                @click="navigateAndClose('/reports')"
            >
                <div class="menu-icon">
                    <ReportIcon :iconClass="{ 'svg-icon-active': routerName === 'reports' }" />
                </div>
                <div class="menu-text">
                    <div class="menu-title">Reports</div>
                    <div class="menu-subtitle">Usage analytics & insights</div>
                </div>
            </a>

            <a 
                href="javascript:void(0)" 
                class="more-menu-item"
                :class="{ 'active': currentRoute === 'device-info' }"
                @click="navigateAndClose('/device-info')"
            >
                <div class="menu-icon">
                    <DeviceIcon :iconClass="{ 'svg-icon-active': routerName === 'device-info' }" />
                </div>
                <div class="menu-text">
                    <div class="menu-title">Device Info</div>
                    <div class="menu-subtitle">Device details & status</div>
                </div>
            </a>

            <a 
                href="javascript:void(0)" 
                class="more-menu-item"
                :class="{ 'active': currentRoute === 'browser-logs' }"
                @click="navigateAndClose('/browser-logs')"
            >
                <div class="menu-icon">
                    <BrowserLogIcons :iconClass="{ 'svg-icon-active': routerName === 'browser-logs' }" />
                </div>
                <div class="menu-text">
                    <div class="menu-title">Browser Logs</div>
                    <div class="menu-subtitle">Web browsing history</div>
                </div>
            </a>

            <a 
                href="javascript:void(0)" 
                class="more-menu-item"
                :class="{ 'active': currentRoute === 'payment-history' }"
                @click="navigateAndClose('/payment-history')"
            >
                <div class="menu-icon">
                    <PaymentHistoryIcon :iconClass="{ 'svg-icon-active': routerName === 'payment-history' }" />
                </div>
                <div class="menu-text">
                    <div class="menu-title">Payment History</div>
                    <div class="menu-subtitle">View past transactions</div>
                </div>
            </a>

            <a 
                href="javascript:void(0)" 
                class="more-menu-item"
                :class="{ 'active': currentRoute === 'payment-methods' }"
                @click="navigateAndClose('/payment-methods')"
            >
                <div class="menu-icon">
                    <PaymentMethodIcon :iconClass="{ 'svg-icon-active': routerName === 'payment-methods' }" />
                </div>
                <div class="menu-text">
                    <div class="menu-title">Payment Methods</div>
                    <div class="menu-subtitle">Manage payment options</div>
                </div>
            </a>

            <a 
                href="javascript:void(0)" 
                class="more-menu-item"
                :class="{ 'active': currentRoute === 'change-password' }"
                @click="navigateAndClose('/change-password')"
            >
                <div class="menu-icon">
                    <ChangePasswordIcon :iconClass="{ 'svg-icon-active': routerName === 'change-password' }" />
                </div>
                <div class="menu-text">
                    <div class="menu-title">Change Password</div>
                    <div class="menu-subtitle">Update account password</div>
                </div>
            </a>

            <a 
                href="javascript:void(0)" 
                class="more-menu-item"
                @click="navigateAndClose('/contact-us')"
            >
                <div class="menu-icon">
                    <NeedHelpIcon :iconClass="{ 'svg-icon-active': routerName === 'contact-us' }" />
                </div>
                <div class="menu-text">
                    <div class="menu-title">Need Help?</div>
                    <div class="menu-subtitle">Contact support</div>
                </div>
            </a>
        </div>
    </div>
</template>

<script>
import KidsService from "../services/KidsService";
import NeedHelpIcon from '@/components/icons/NeedHelpIcon.vue'
import DashboardIcon from '@/components/icons/DashboardIcon.vue'
import ApplicationsIcon from '@/components/icons/ApplicationsIcon.vue'
import AppRequestListIcon from '@/components/icons/AppRequestListIcon.vue'
import BrowserLogIcons  from '@/components/icons/BrowserLogIcons.vue'
import PaymentHistoryIcon  from '@/components/icons/PaymentHistoryIcon.vue'
import PaymentMethodIcon from '@/components/icons/PaymentMethodIcon.vue'
import ChangePasswordIcon from '@/components/icons/ChangePasswordIcon.vue'
import ThreeLineMenuIcon from '@/components/icons/ThreeLineMenuIcon.vue'
import NotificationBellIcon from '@/components/icons/NotificationBellIcon.vue'
import ScheduleIcon from '@/components/icons/ScheduleIcon.vue'
import SettingIcon from '@/components/icons/SettingIcon.vue'
import DeviceIcon from '@/components/icons/DeviceIcon.vue'
import AddressBookIcon from '@/components/icons/AddressBookIcon.vue'
import ReportIcon from '@/components/icons/ReportIcon.vue'
import GeofenceIcon from '@/components/icons/GeofenceIcon.vue'
import LogoutIcon from '@/components/icons/LogoutIcon.vue'
import QrCodeIcon from '@/components/icons/QrCodeIcon.vue'
import CrossCloseIcon from '@/components/icons/CrossCloseIcon.vue'
import ChromeIcon  from '@/components/icons/ChromeIcon.vue'

export default {
    name: 'KidFooter',
    components: {
        ChromeIcon,
        PaymentMethodIcon,
        DashboardIcon,
        ApplicationsIcon,
        AppRequestListIcon,
        BrowserLogIcons,
        PaymentHistoryIcon,
        ChangePasswordIcon,
        ThreeLineMenuIcon,
        NotificationBellIcon,
        NeedHelpIcon,
        ScheduleIcon,
        SettingIcon,
        DeviceIcon,
        AddressBookIcon,
        ReportIcon,
        GeofenceIcon
    },
    props: {
        profileId: String,
        serialNumber: String,
        requestCount: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            currentRoute: this.$route.name,
            showMoreMenu: false,
            routerName: this.$route.name,
            enableSchedule: false,
        }
    },
    methods: {
        toggleMoreMenu() {
            this.showMoreMenu = !this.showMoreMenu;
            if (this.showMoreMenu) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        },
        closeMoreMenu() {
            this.showMoreMenu = false;
            document.body.style.overflow = '';
        },
        navigateTo(path) {
            this.$router.push({ 
                path: path, 
                query: { 
                    profileId: this.profileId, 
                    serialNumber: this.serialNumber 
                } 
            });
        },
        navigateAndClose(path) {
            this.closeMoreMenu();
            this.navigateTo(path);
        },
        async unReadNotificationCount() {
            let data = {
                serialNumber: this.serialNumber,
                profileId: this.profileId
            }
            await KidsService.unReadNotificationCount(data)
            .then((response) => {
                this.enableSchedule = response.data.enableSchedule
            }).catch((e) => {
                this.$toast.error(e.response.data.respones_msg);
                if (e.response.data.is_logout == true) {
                    this.$router.push({ path: '/login'})
                }
            });
        },
    },
    watch: {
        '$route.name'(newName) {
            this.currentRoute = newName;
            this.closeMoreMenu();
        }
    },
    beforeMount() {
        this.unReadNotificationCount();
    },
}
</script>

<style scoped>
.footer {
    background-color: #2c2f33;
    color: white;
    padding: 16px;
    text-align: center;
    font-size: 14px;
}

.footer hr {
    border: none;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    margin: 12px auto;
    width: 80%;
}

.footer-links {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.footer-links a {
    color: #ffffff;
    text-decoration: none;
}

.footer-links a:hover {
    text-decoration: underline;
}

/* Bottom Navigation */
.bottom-nav-container {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: white;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.bottom-nav {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 65px;
    max-width: 600px;
    margin: 0 auto;
    background: white;
}

.nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex: 1;
    height: 100%;
    text-decoration: none;
    color: #666;
    transition: all 0.3s ease;
    position: relative;
}

.nav-item span {
    font-size: 11px;
    margin-top: 4px;
    font-weight: 500;
}

.nav-item.active {
    color: #6366f1;
}

.nav-item.active::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 3px;
    background: #6366f1;
    border-radius: 0 0 3px 3px;
}

/* More Menu Overlay */
.more-menu-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 1001;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
}

.more-menu-overlay.show {
    opacity: 1;
    visibility: visible;
}

/* More Menu Panel */
.more-menu-panel {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    border-radius: 20px 20px 0 0;
    z-index: 1002;
    transform: translateY(100%);
    transition: transform 0.3s ease;
    max-height: 80vh;
    overflow-y: auto;
}

.more-menu-panel.show {
    transform: translateY(0);
}

.more-menu-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 20px 15px;
    border-bottom: 1px solid #e5e7eb;
    position: sticky;
    top: 0;
    background: white;
    z-index: 10;
}

.more-menu-header h5 {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 700;
    color: #1f2937;
}

.close-btn {
    background: #f3f4f6;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s ease;
}

.close-btn:hover {
    background: #e5e7eb;
}

.more-menu-content {
    padding: 10px 0 80px;
}

.more-menu-item {
    display: flex;
    align-items: center;
    padding: 16px 20px;
    text-decoration: none;
    color: #1f2937;
    transition: background 0.2s ease;
    border-bottom: 1px solid #f3f4f6;
}

.more-menu-item:hover {
    background: #f9fafb;
}

.more-menu-item.active {
    background: #eff6ff;
    border-left: 4px solid #6366f1;
}

.menu-icon {
    width: 48px;
    height: 48px;
    background: #f3f4f6;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    flex-shrink: 0;
}

.more-menu-item.active .menu-icon {
    background: #dbeafe;
}

.menu-text {
    flex: 1;
}

.menu-title {
    font-size: 1rem;
    font-weight: 600;
    color: #1f2937;
    margin-bottom: 2px;
}

.menu-subtitle {
    font-size: 0.85rem;
    color: #6b7280;
}

.badge {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 0.75rem;
    font-weight: 600;
}

.badge-warning {
    background: #fef3c7;
    color: #92400e;
}

/* Responsive */
@media (min-width: 640px) {
    .footer-links {
        flex-direction: row;
        justify-content: center;
        flex-wrap: wrap;
        gap: 16px;
    }
    
    .bottom-nav-container {
        display: none; /* Hide bottom nav on desktop if needed */
    }
}

@media (max-width: 639px) {
    .more-menu-panel {
        max-height: 85vh;
    }
    .footer-spacing {
        margin-bottom: 80px; /* Space for fixed bottom nav */
    }
}

.icon-wrapper {
    position: relative;
    display: inline-flex;
}

.new-badge {
    position: absolute;
    top: -8px;
    right: -12px;
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
    font-size: 8px;
    font-weight: 700;
    padding: 2px 5px;
    border-radius: 8px;
    text-transform: uppercase;
    animation: pulse-badge 2s infinite;
}

@keyframes pulse-badge {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.08); }
}
</style>